(() => {
  const root = document.querySelector('[data-pa-camera]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  document.body.classList.add('pa-camera-page');
  document.title = 'Cámara Aparte — Punto Aparte';

  const screens = [...root.querySelectorAll('[data-pa-screen]')];
  const state = root.querySelector('[data-pa-state]');
  const video = root.querySelector('[data-pa-video]');
  const empty = root.querySelector('[data-pa-empty]');
  const fileInput = root.querySelector('[data-pa-file]');
  const canvas = root.querySelector('[data-pa-canvas]');
  const ctx = canvas.getContext('2d');
  const fxCanvas = root.querySelector('[data-pa-fx]');
  const fx = fxCanvas.getContext('2d');
  const liveTitle = root.querySelector('[data-pa-live-title]');
  const routeCount = root.querySelector('[data-pa-route-count]');
  const routeName = root.querySelector('[data-pa-route-name]');
  const resultRoute = root.querySelector('[data-pa-result-route]');
  const saveHelp = root.querySelector('[data-pa-save-help]');
  const isotipo = new Image();
  isotipo.src = root.dataset.isotipo;

  const routeNames = [
    'UMBRAL CROMO','PLIEGUE ORBITAL','CAMPO IRIDISCENTE','VECTOR LÍQUIDO','HORIZONTE REVERSIBLE',
    'NODO DE DECISIÓN','PORTAL DOBLE','TRAZO GRAVITACIONAL','MEMORIA DE RUTA','DESFASE ESENCIAL'
  ];
  const paths = [
    [[-.14,.78],[.14,.68,.08,.36,.36,.38],[.58,.40,.42,.82,.76,.67],[.96,.52,.82,.18,1.14,.22]],
    [[-.10,.18],[.18,.02,.20,.53,.48,.42],[.77,.30,.63,.81,1.08,.72]],
    [[-.18,.60],[.15,.38,.20,.86,.53,.66],[.78,.50,.70,.18,1.16,.31]],
    [[.10,1.10],[.03,.80,.34,.70,.26,.48],[.18,.23,.55,.18,.53,-.10]],
    [[-.12,.52],[.15,.28,.34,.29,.52,.51],[.70,.75,.88,.72,1.14,.48]],
    [[-.08,.84],[.18,.66,.14,.35,.42,.49],[.58,.61,.66,.21,.84,.34],[.95,.42,.91,.70,1.12,.62]],
    [[-.18,.30],[.10,.10,.34,.10,.46,.34],[.58,.57,.77,.55,1.15,.30]],
    [[.18,-.12],[.02,.20,.36,.31,.25,.55],[.15,.79,.57,.88,.49,1.12]],
    [[-.08,.72],[.14,.57,.25,.77,.39,.58],[.55,.39,.66,.47,.79,.28],[.90,.17,1.01,.26,1.10,.10]],
    [[-.10,.40],[.13,.22,.27,.31,.42,.46],[.59,.63,.73,.54,1.12,.76]]
  ];
  const nodeSets = [
    [[.12,.61],[.36,.38],[.75,.67]],[[.18,.17],[.49,.42],[.83,.66]],[[.17,.56],[.52,.66],[.83,.31]],
    [[.08,.83],[.26,.48],[.52,.08]],[[.18,.39],[.52,.51],[.87,.63]],[[.15,.69],[.42,.49],[.83,.34]],
    [[.18,.19],[.46,.34],[.78,.48]],[[.11,.18],[.25,.55],[.48,.91]],[[.17,.65],[.39,.58],[.78,.29]],[[.16,.34],[.42,.46],[.78,.60]]
  ];
  const states = {intro:'UMBRAL',choice:'DECISIÓN',camera:'RUTA VIVA',result:'REGISTRO'};
  let stream = null;
  let facing = 'environment';
  let mode = 'route';
  let outputBlob = null;
  let routeIndex = randomRoute();
  let animationFrame = 0;
  let activeScreen = 'intro';

  const emit = (name, detail = {}) => window.dispatchEvent(new CustomEvent(`pa_camera_${name}`, {detail}));
  const pad = number => String(number + 1).padStart(2,'0');

  function randomRoute() {
    if (globalThis.crypto?.getRandomValues) {
      const value = new Uint32Array(1); globalThis.crypto.getRandomValues(value); return value[0] % routeNames.length;
    }
    return Math.floor(Math.random() * routeNames.length);
  }

  function copyForMode() {
    return mode === 'selfie'
      ? {html:'NO SEGUÍ LA RUTA.<br>LA HICE.', lines:['NO SEGUÍ LA RUTA.','LA HICE.']}
      : {html:'ESTA RUTA NO SE SIGUE.<br>SE CONSTRUYE.', lines:['ESTA RUTA NO SE SIGUE.','SE CONSTRUYE.']};
  }

  function updateRouteUI() {
    const label = `RUTA ${pad(routeIndex)} / 10`;
    routeCount.textContent = label;
    routeName.textContent = routeNames[routeIndex];
    resultRoute.textContent = label;
  }

  function stopCamera() {
    if (stream) stream.getTracks().forEach(track => track.stop());
    stream = null; video.srcObject = null;
  }

  function show(name) {
    activeScreen = name;
    screens.forEach(screen => {
      const active = screen.dataset.paScreen === name;
      screen.hidden = !active; screen.classList.toggle('is-active',active);
    });
    state.textContent = states[name] || '';
    if (name !== 'camera') stopCamera();
    root.scrollIntoView({block:'start',behavior:'smooth'});
    emit('screen_view',{screen:name});
  }

  async function startCamera() {
    stopCamera(); empty.classList.remove('is-visible');
    if (!navigator.mediaDevices?.getUserMedia) { empty.classList.add('is-visible'); return; }
    try {
      stream = await navigator.mediaDevices.getUserMedia({video:{facingMode:{ideal:facing},width:{ideal:1080},height:{ideal:1920}},audio:false});
      video.srcObject = stream;
      video.style.transform = mode === 'selfie' ? 'scaleX(-1)' : 'none';
      emit('camera_open',{mode});
    } catch (error) {
      empty.classList.add('is-visible'); emit('camera_error',{name:error?.name || 'unknown'});
    }
  }

  function buildPath(target,w,h,index) {
    const definition = paths[index];
    target.beginPath(); target.moveTo(definition[0][0]*w,definition[0][1]*h);
    definition.slice(1).forEach(c => target.bezierCurveTo(c[0]*w,c[1]*h,c[2]*w,c[3]*h,c[4]*w,c[5]*h));
  }

  function chromeGradient(target,w,index) {
    const g = target.createLinearGradient(0,0,w,0);
    if (index === 2) {
      g.addColorStop(0,'rgba(188,218,248,.9)'); g.addColorStop(.24,'rgba(255,255,255,.95)'); g.addColorStop(.48,'rgba(207,181,255,.9)'); g.addColorStop(.70,'rgba(126,230,241,.95)'); g.addColorStop(1,'rgba(14,48,234,.92)');
    } else if (index === 5) {
      g.addColorStop(0,'#0e30ea'); g.addColorStop(.42,'#eef4ff'); g.addColorStop(.68,'#ffed00'); g.addColorStop(1,'#737985');
    } else {
      g.addColorStop(0,'#24262b'); g.addColorStop(.16,'#ffffff'); g.addColorStop(.34,'#737985'); g.addColorStop(.51,'#eef4ff'); g.addColorStop(.68,'#0e30ea'); g.addColorStop(.84,'#ffffff'); g.addColorStop(1,'#34363d');
    }
    return g;
  }

  function drawRoute(target,w,h,index,time=0) {
    target.save(); target.lineCap='round'; target.lineJoin='round';
    const pulse = Math.sin(time/650 + index) * Math.min(w,h) * .004;
    target.save(); target.translate(w*.012,h*.014); buildPath(target,w,h,index); target.strokeStyle='rgba(0,0,0,.58)'; target.lineWidth=w*.09+pulse; target.shadowColor='rgba(0,0,0,.75)'; target.shadowBlur=w*.05; target.stroke(); target.restore();
    buildPath(target,w,h,index); target.strokeStyle='#26282e'; target.lineWidth=w*.077+pulse; target.stroke();
    buildPath(target,w,h,index); target.strokeStyle=chromeGradient(target,w,index); target.lineWidth=w*.062+pulse; target.shadowColor=index===2?'rgba(188,218,248,.7)':'rgba(14,48,234,.42)'; target.shadowBlur=w*.025; target.stroke(); target.shadowBlur=0;
    buildPath(target,w,h,index); target.strokeStyle='rgba(255,255,255,.72)'; target.lineWidth=w*.009; target.stroke();
    buildPath(target,w,h,index); target.setLineDash([w*.028,w*.045]); target.lineDashOffset=-(time/32); target.strokeStyle='rgba(188,218,248,.42)'; target.lineWidth=w*.0035; target.stroke(); target.setLineDash([]);
    nodeSets[index].forEach((node,nodeIndex) => {
      const x=node[0]*w,y=node[1]*h,r=w*(nodeIndex===1?.022:.016)+pulse*.25;
      const ng=target.createRadialGradient(x-r*.3,y-r*.3,r*.1,x,y,r);
      ng.addColorStop(0,'#fff'); ng.addColorStop(.38,nodeIndex===1?'#ffed00':'#bcdaf8'); ng.addColorStop(1,nodeIndex===1?'rgba(255,237,0,.15)':'rgba(14,48,234,.18)');
      target.beginPath(); target.arc(x,y,r,0,Math.PI*2); target.fillStyle=ng; target.shadowColor=nodeIndex===1?'#ffed00':'#bcdaf8'; target.shadowBlur=r*.8; target.fill(); target.shadowBlur=0;
    });
    target.restore();
  }

  function animate(time) {
    fx.clearRect(0,0,fxCanvas.width,fxCanvas.height);
    if (activeScreen === 'camera') drawRoute(fx,fxCanvas.width,fxCanvas.height,routeIndex,time);
    animationFrame = requestAnimationFrame(animate);
  }

  function drawCover(source,sourceWidth,sourceHeight) {
    const tw=canvas.width,th=canvas.height,scale=Math.max(tw/sourceWidth,th/sourceHeight);
    const width=sourceWidth*scale,height=sourceHeight*scale,x=(tw-width)/2,y=(th-height)/2;
    ctx.save();
    if (mode==='selfie' && source===video) { ctx.translate(tw,0);ctx.scale(-1,1);ctx.drawImage(source,-x-width,y,width,height); }
    else ctx.drawImage(source,x,y,width,height);
    ctx.restore();
  }

  function drawTextBlock() {
    const gradient=ctx.createLinearGradient(0,0,0,520);gradient.addColorStop(0,'rgba(0,0,0,.68)');gradient.addColorStop(1,'rgba(0,0,0,0)');ctx.fillStyle=gradient;ctx.fillRect(0,0,canvas.width,540);
    const lines=copyForMode().lines;
    ctx.fillStyle='#f7f7f7';ctx.textBaseline='top';ctx.font='700 62px Arial';ctx.fillText(lines[0],64,76);ctx.fillText(lines[1],64,146);
    ctx.fillStyle='#bcdaf8';ctx.font='500 24px Courier New';ctx.fillText('LO ESENCIAL SIGUE EN MOVIMIENTO.',64,232);
    ctx.fillStyle='#ffed00';ctx.font='700 20px Courier New';ctx.fillText(`RUTA ${pad(routeIndex)} / 10  ·  ${routeNames[routeIndex]}`,64,278);
    const bottom=ctx.createLinearGradient(0,1450,0,1920);bottom.addColorStop(0,'rgba(0,0,0,0)');bottom.addColorStop(1,'rgba(0,0,0,.78)');ctx.fillStyle=bottom;ctx.fillRect(0,1420,1080,500);
    ctx.fillStyle='#f7f7f7';ctx.font='600 27px Arial';ctx.fillText('@puntoaparte.co',64,1818);
    if (isotipo.complete && isotipo.naturalWidth) { const iw=230,ih=iw*(isotipo.naturalHeight/isotipo.naturalWidth);ctx.drawImage(isotipo,1080-64-iw,1798,iw,ih); }
  }

  async function drawResult(source,width,height) {
    ctx.clearRect(0,0,canvas.width,canvas.height);drawCover(source,width,height);drawRoute(ctx,canvas.width,canvas.height,routeIndex,performance.now());drawTextBlock();
    outputBlob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png',1));show('result');emit('capture_complete',{mode,route:routeIndex+1});
  }

  function downloadFile() {
    if (!outputBlob) return;const link=document.createElement('a'),url=URL.createObjectURL(outputBlob);link.href=url;link.download='mi-ruta-punto-aparte.png';link.click();setTimeout(()=>URL.revokeObjectURL(url),1200);emit('download');
  }

  async function nativeShare(intent) {
    if (!outputBlob) return;
    const file=new File([outputBlob],'mi-ruta-punto-aparte.png',{type:'image/png'});
    const data=intent==='share'
      ? {title:'Mi ruta — Punto Aparte',text:'No seguí la ruta. La hice. @puntoaparte.co',files:[file]}
      : {title:'Guardar en Fotos — Punto Aparte',files:[file]};
    if (navigator.canShare?.({files:[file]})) {
      saveHelp.textContent=intent==='save'?'Selecciona “Guardar imagen”, Fotos o Galería en el menú del teléfono.':'Elige dónde quieres compartir tu ruta.';
      try { await navigator.share(data);emit(intent,{route:routeIndex+1}); } catch(error) { if (error?.name!=='AbortError') downloadFile(); }
    } else { saveHelp.textContent='Este navegador guardará la imagen como archivo.';downloadFile(); }
  }

  root.querySelectorAll('[data-pa-go]').forEach(button=>button.addEventListener('click',()=>show(button.dataset.paGo)));
  root.querySelectorAll('[data-pa-mode]').forEach(button=>button.addEventListener('click',async()=>{
    mode=button.dataset.paMode;facing=mode==='selfie'?'user':'environment';liveTitle.innerHTML=copyForMode().html;show('camera');await startCamera();
  }));
  root.querySelector('[data-pa-next-route]').addEventListener('click',()=>{routeIndex=(routeIndex+1)%routeNames.length;updateRouteUI();emit('route_change',{route:routeIndex+1});});
  root.querySelector('[data-pa-switch]').addEventListener('click',async()=>{facing=facing==='environment'?'user':'environment';await startCamera();});
  root.querySelector('[data-pa-capture]').addEventListener('click',async()=>{if(!video.videoWidth)return empty.classList.add('is-visible');await drawResult(video,video.videoWidth,video.videoHeight);});
  fileInput.addEventListener('change',()=>{const file=fileInput.files?.[0];if(!file)return;const image=new Image(),url=URL.createObjectURL(file);image.onload=async()=>{await drawResult(image,image.naturalWidth,image.naturalHeight);URL.revokeObjectURL(url);};image.src=url;});
  root.querySelector('[data-pa-save]').addEventListener('click',()=>nativeShare('save'));
  root.querySelector('[data-pa-share]').addEventListener('click',()=>nativeShare('share'));
  root.querySelector('[data-pa-download]').addEventListener('click',downloadFile);
  root.querySelector('[data-pa-repeat]').addEventListener('click',async()=>{show('camera');await startCamera();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stopCamera();});window.addEventListener('pagehide',()=>{stopCamera();cancelAnimationFrame(animationFrame);});
  updateRouteUI();requestAnimationFrame(animate);emit('loaded',{version:'09'});
})();
